// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__pskjH","inner":"Form_inner__2dzvp","range":"Form_range__19kkO","name":"Form_name__16Psh","actions":"Form_actions__3OhtH"};